import * as React from 'react';
import { Typography, Box, Container, CircularProgress, Paper } from '@mui/material';
import { connect } from "react-redux";
import { isMobile } from 'react-device-detect';
import { centered_flex_box } from '../../app/components/Styles';
import { useLocation } from 'react-router-dom';
import { checkTransaction } from '../../app/store/actions/userActions';
import { CreditCardOff, CreditScore } from '@mui/icons-material';
import { notification } from 'antd';
import {
  marketingColors,
  userAccountShellSx,
  eventSurfacePaperSx,
  sectionTitleSx,
} from '../../app/components/tickitMarketingTheme';

export const CheckTransaction = ({ checkTransaction, isSuccessful, isLoading }) => {

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const params = {};
    for (const [key, value] of searchParams.entries()) {
        params[key] = value;
    }

    React.useEffect(() => {
        notification.info({ message: "Fetching transaction", style: { marginTop: "10vh" } });
        checkTransaction({ transaction_id: params.id })
    }, [])

    if (isLoading) {
        return (
            <Box sx={{ ...userAccountShellSx, ...centered_flex_box, minHeight: "100vh" }}>
                <CircularProgress sx={{ color: marketingColors.p700 }} />
            </Box>
        )
    }

    return (
        <Box sx={userAccountShellSx}>
            <Container maxWidth="sm" sx={{ px: isMobile ? 2 : 3, position: "relative", zIndex: 1 }}>
                <Paper elevation={0} sx={{ ...eventSurfacePaperSx, p: { xs: 4, sm: 5 }, textAlign: "center" }}>
                    {isSuccessful ? (
                        <Box sx={{ ...centered_flex_box, flexDirection: "column", py: 2 }}>
                            <CreditScore sx={{ fontSize: 64, color: marketingColors.green, mb: 2 }} />
                            <Typography sx={{ ...sectionTitleSx, fontSize: { xs: "1.5rem", sm: "1.75rem" }, color: marketingColors.gray900 }}>
                                Transaction successful
                            </Typography>
                            <Typography sx={{ mt: 1, color: marketingColors.gray600, fontFamily: "'Plus Jakarta Sans', TickitTwo, Helvetica, Arial, sans-serif" }}>
                                Your payment was processed.
                            </Typography>
                        </Box>
                    ) : (
                        <Box sx={{ ...centered_flex_box, flexDirection: "column", py: 2 }}>
                            <CreditCardOff sx={{ fontSize: 64, color: marketingColors.gray400, mb: 2 }} />
                            <Typography sx={{ ...sectionTitleSx, fontSize: { xs: "1.5rem", sm: "1.75rem" }, color: marketingColors.gray900 }}>
                                Transaction failed
                            </Typography>
                            <Typography sx={{ mt: 1, color: marketingColors.gray600, fontFamily: "'Plus Jakarta Sans', TickitTwo, Helvetica, Arial, sans-serif" }}>
                                We could not complete this payment. Try again or use another method.
                            </Typography>
                        </Box>
                    )}
                </Paper>
            </Container>
        </Box>
    );
}

const mapStateToProps = (state) => ({
    isSuccessful: state?.records?.results?.success,
    isLoading: state?.records?.isLoading,
    user: state?.auth?.user
});

const mapDispatchToProps = { checkTransaction };

export default connect(mapStateToProps, mapDispatchToProps)(CheckTransaction);
